import { create } from 'zustand';
import { createDialogSlice, DialogState } from './dialog/dialogSlice';
import { createDrawerSlice, DrawerState } from './drawer/drawerSlice';
import { createFilterSlice, FilterState } from './filter/filterSlice';

export const useAppZStore = create<DialogState & DrawerState & FilterState>((...a) => ({
  ...createDialogSlice(...a),
  ...createDrawerSlice(...a),
  ...createFilterSlice(...a),
}));
